export function mapBuilders(prefixes = {}) {
  return Object.fromEntries(Object.entries(prefixes).map(([prefix, ns]) => [prefix, typeof ns === 'string' ? ns : ns().value]));
}
export function getNamespaces(prefixes, prefixMap) {
  return [...prefixes].filter(prefix => prefix in prefixMap).map(prefix => [prefix, prefixMap[prefix]]);
}